import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectCountry, selectDelivery, selectShowInvalids } from '@store/partners-order/selectors';
import { setDelivery } from '@store/partners-order/slice';
import Checkbox from '@components/checkbox/Checkbox';
import { invalidFormValue } from '@components/utils';
import { useLazyGetDeliveryTypesQuery } from '@api/baseApi';
import { DeliveryTypeDef } from '@api/types/DeliveryTypeDef';
import { getFormattedPrice } from '@translations/functions';



const Shipping = () => {
	const { t } = useTranslation('forms');

	const country = useSelector(selectCountry);
	const delivery = useSelector(selectDelivery);
	const showInvalids = useSelector(selectShowInvalids);

	const dispatch = useDispatch();
	const updateDelivery = (value: DeliveryTypeDef | null) => dispatch(setDelivery(value));

	const [ getDeliveryTypes, { data, isLoading, isFetching, isError, isSuccess } ] = useLazyGetDeliveryTypesQuery();

	useEffect(() => {
		if (country) {
			getDeliveryTypes({ country }, true);
		}
	}, [ country ]);

	return (
		<div className='shipping-section'>

			<label className='shipping-label'>
				{t('paymentShipping.shipping.sectionLabel') + ' '}<span>*</span> {showInvalids && invalidFormValue(delivery) &&
					<p className='form-invalid'>{t('validation.requiredField')}</p>}
			</label>

			{isError &&
				<p className='error-message'>{t('paymentShipping.errorMessage')}</p>}

			{(isLoading || isFetching) &&
				<p className='loading-message'>{t('paymentShipping.loadingMessage')}</p>}

			{isSuccess && data && data.length === 0 &&
				<p className='info-message'>{t('paymentShipping.shipping.emptyMessage')}</p>}

			{isSuccess && data && data.length > 0 && data.map(x =>
				<Checkbox isSelected={delivery !== null && delivery.id === x.id} onChange={() => updateDelivery(x)} isRequired={true} key={`partners-order-form-delivery-${x.id}`}>
					{`${x.description} (${
						x.price === 0 ? t('units.free') : getFormattedPrice(country, x.price)
					})`}
				</Checkbox>)}
		</div>
	);
};

export default Shipping;